import React, { useState, useEffect } from "react";
import "../css/reset.css";
import "../css/contact.css";
import emailjs from "@emailjs/browser";
import { valueCheck } from "../util/valueCheck";
import ContactDetailModal from "./ContactDetailModal"; // Import the new modal component

// 데이터 전송 형태
// 문의 종류
const inquiryTypes = [
  { id: "user_select_App", label: "앱개발", formKey: "chk1" },
  { id: "user_select_Web", label: "웹개발", formKey: "chk2" },
  {
    id: "user_select_etc",
    label: "기타",
    formKey: "chk3",
    hasTextInput: true,
    textInputKey: "check3",
    placeholder: "상세 내용",
  },
];

// 개발 유형
const DevelopmentType = [
  { id: "iot_communication", label: "IoT/통신", formKey: "chk4" },
  { id: "mediation_platform", label: "중개/플랫폼", formKey: "chk5" },
  { id: "homepage", label: "홈페이지", formKey: "chk6" },
  { id: "gps_remote", label: "GPS/원격", formKey: "chk7" },
  { id: "store_management", label: "매장관리", formKey: "chk8" },
  { id: "logistics_inventory", label: "물류/재고", formKey: "chk9" },
  { id: "business", label: "비즈니스", formKey: "chk10" },
  { id: "medical_hospital", label: "의료/병원", formKey: "chk11" },
  { id: "table_order", label: "테이블 오더", formKey: "chk12" },
  { id: "shopping_mall", label: "쇼핑몰", formKey: "chk13" },
  {
    id: "development_select_etc",
    label: "기타",
    formKey: "chk14",
    hasTextInput: true,
    textInputKey: "check14",
    placeholder: "서비스 내용",
  },
];

// 알게된 경로
const pathOptions = [
  {
    id: "user_path_search_naver",
    label: "네이버 검색",
    formKey: "chk15",
    hasTextInput: true,
    textInputKey: "check15",
    placeholder: "검색 키워드를 적어주세요.",
  },
  {
    id: "user_path_search_another",
    label: "네이버 외 사이트 검색",
    formKey: "chk16",
    hasTextInput: true,
    textInputKey: "check16",
    placeholder: "사이트 명 / 검색어",
  },
  {
    id: "user_path_datafive_blog",
    label: "네이버 블로그",
    formKey: "chk17",
  },
  { id: "user_path_youtube", label: "유튜브", formKey: "chk18" },
  { id: "user_path_instagram", label: "인스타그램", formKey: "chk19" },
  { id: "user_path_exhibition", label: "전시회", formKey: "chk20" },
  { id: "user_path_news", label: "언론/보도자료", formKey: "chk21" },
  { id: "user_path_email", label: "이메일 광고", formKey: "chk22" },
  { id: "user_path_friend", label: "지인소개", formKey: "chk23" },
  { id: "user_path_banner", label: "배너광고", formKey: "chk24" },
  {
    id: "user_else_path",
    label: "기타",
    formKey: "chk25",
    hasTextInput: true,
    textInputKey: "check25",
    placeholder: "알게된 경로",
  },
];

const Contact = () => {
  const [VW, setVW] = useState(window.innerWidth);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [form, setForm] = useState({
    name: "",
    company: "",
    phone: "",
    position: "",
    email1: "",
    email2: "",
    // Checkbox states for inquiryTypes (chk1-chk3, check3)
    chk1: false,
    chk2: false,
    chk3: false,
    check3: "",
    // Checkbox states for DevelopmentType (chk4-chk14, check14)
    chk4: false,
    chk5: false,
    chk6: false,
    chk7: false,
    chk8: false,
    chk9: false,
    chk10: false,
    chk11: false,
    chk12: false,
    chk13: false,
    chk14: false,
    check14: "",
    // Checkbox states for pathOptions (chk15-chk25, check15, check16, check25)
    chk15: false,
    chk16: false,
    chk17: false,
    chk18: false,
    chk19: false,
    chk20: false,
    chk21: false,
    chk22: false,
    chk23: false,
    chk24: false,
    chk25: false,
    check15: "",
    check16: "",
    check25: "",
    inquiry: "",
    personal: false,
    preferEmail: false,
    preferPhone: false,
  });
  const [modalBg, setModalBg] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setVW(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const loadScript = (src, callback) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = callback;
      document.body.appendChild(script);
    };

    loadScript("//wcs.naver.net/wcslog.js", () => {
      setScriptLoaded(true);
    });
  }, []);

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const namecharacterCheck = (e) => {
    let text = e.target.value;
    const regExp = /[ {}[\\\]/?.,;:|)*~`!^\-_+┼<>@#$%&'"\\(=]/gi;
    const regExp2 = /[0-9]+$/g;
    if (regExp.test(text) || regExp2.test(text)) {
      text = text.substring(0, text.length - 1);
    }
    setForm({ ...form, name: text });
  };

  const emailcharacterCheck = (e) => {
    let text = e.target.value;
    const regExp2 = /[ {}[\\\]/?.,;:|)*~`!^\-_+┼<>@#$%&'"\\(=]/gi;
    if (regExp2.test(text)) {
      text = text.substring(0, text.length - 1);
    }
    setForm({ ...form, email1: text });
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    const cleaned = phoneNumber.replace(/\D/g, "");
    let formatted = cleaned;

    if (cleaned.length > 10) {
      formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    } else if (cleaned.length > 7) {
      if (cleaned.startsWith("02")) {
        formatted = cleaned.replace(/(\d{2})(\d{3,4})(\d{4})/, "$1-$2-$3");
      } else {
        formatted = cleaned.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
      }
    } else if (cleaned.length > 3) {
      formatted = cleaned.replace(/(\d{3})(\d{3})/, "$1-$2");
    }
    return formatted;
  };

  const phonecharacterCheck = (e) => {
    let text = e.target.value;
    const cleanedText = text.replace(/\D/g, "");
    const formattedText = formatPhoneNumber(cleanedText);
    setForm({ ...form, phone: formattedText });
  };

  const handleEmailSelectChange = (e) => {
    if (e.target.value === "직접입력") {
      setForm({ ...form, email2: "" });
    } else {
      setForm({ ...form, email2: e.target.value });
    }
  };

  const handleEmailTextInputChange = (e) => {
    let text = e.target.value;
    const regExp = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    const regExp2 = /[ {}[\\\]/?,;:|)*~`!^\-_+┼<>@#$%&'"\\(=]/gi;
    if (regExp.test(text) || regExp2.test(text)) {
      text = text.substring(0, text.length - 1);
    }
    setForm({ ...form, email2: text });
  };

  const contactSubmit = async (e) => {
    e.preventDefault();
    const chkboxlength = document.querySelectorAll(
      '.contact_input_wrap.type2 input[type="checkbox"]:checked'
    ).length;

    const templateParams = valueCheck(form, chkboxlength);
    if (templateParams) {
      emailjs
        .send(
          "service_tuurz8q",
          "template_pyy6jid",
          templateParams,
          "user_VdREZsoaD7r3NOvO9JTIO"
        )
        .then(
          (response) => {
            // console.log("SUCCESS!", response.status, response.text);
            alert("문의 신청을 완료 하였습니다.");

            if (scriptLoaded && window.wcs) {
              if (!window.wcs_add) {
                window.wcs_add = {};
              }
              window.wcs_add = { wa: "s_2741cfab16ae" };
              const _nasa = {};
              _nasa["cnv"] = window.wcs.cnv("5", "0");
              window.wcs_do(_nasa);
              // console.log("NAVER Analytics log sent:", _nasa);
            }
            window.location.reload();
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );
    }
  };

  const contactDetailBtn = () => {
    setModalBg(true);
  };

  const closeModal = () => {
    setModalBg(false);
  };

  return (
    <>
      <section
        className="contact_wrap"
        id="contactSection"
        name="contactSection"
      >
        <div className="contact_inner">
          <div className="title_wrap">
            <h3>CONTACT</h3>
            <strong>데이터파이브에 문의하기</strong>
          </div>

          <div className="contact_content_wrap">
            <div className="contact_img_wrap">
              <span></span>
            </div>

            <div className="contact_main_wrap">
              <div className="contact_user_info_wrap">
                <div className="contact_user_title_wrap1">
                  <strong>1. 고객정보</strong>
                </div>

                <div className="contact_input_wrap type1 ">
                  <ul>
                    <li>
                      <div>
                        <span>*</span>
                        <label htmlFor="user_name">이름</label>
                      </div>
                      <div>
                        <input
                          id="user_name"
                          type="text"
                          placeholder="홍길동"
                          tabIndex={1}
                          maxLength={10}
                          title="성함"
                          autoComplete="off"
                          onChange={namecharacterCheck}
                          value={form.name}
                          required
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <span>*</span>
                        <label htmlFor="user_company">회사명</label>
                      </div>
                      <div>
                        <input
                          id="user_company"
                          type="text"
                          placeholder="데이터파이브"
                          tabIndex={1}
                          maxLength={30}
                          title="회사명"
                          autoComplete="off"
                          required
                          name="company"
                          onChange={handleFormChange}
                          value={form.company}
                        />
                      </div>
                    </li>
                  </ul>

                  <ul>
                    <li>
                      <div>
                        <span>*</span>
                        <label htmlFor="user_phone">연락처</label>
                      </div>
                      <div>
                        <input
                          id="user_phone"
                          type="text"
                          placeholder="010-1234-5678"
                          tabIndex={1}
                          maxLength={13}
                          onChange={phonecharacterCheck}
                          value={form.phone}
                          required
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <label htmlFor="user_position">소속/직책</label>
                      </div>
                      <div>
                        <input
                          id="user_position"
                          type="text"
                          placeholder="마케팅팀/대리"
                          tabIndex={1}
                          maxLength={30}
                          title="직급/소속"
                          autoComplete="off"
                          required
                          name="position"
                          value={form.position}
                          onChange={handleFormChange}
                        />
                      </div>
                    </li>
                  </ul>

                  <ul>
                    <li>
                      <div>
                        <span>*</span>
                        <label htmlFor="user_email">이메일</label>
                      </div>
                      <div className="user_email_wrap">
                        <input
                          id="user_email"
                          type="text"
                          tabIndex={1}
                          autoComplete="off"
                          onChange={emailcharacterCheck}
                          value={form.email1}
                        />
                        <div>
                          <label
                            htmlFor="user_email2"
                            className="user_email2 blind"
                          >
                            이메일주소
                          </label>
                          <input
                            id="user_email2"
                            type="text"
                            tabIndex={1}
                            autoComplete="off"
                            onChange={handleEmailTextInputChange}
                            value={form.email2}
                          />
                        </div>
                        <select
                          id="user_email_list"
                          tabIndex={1}
                          defaultValue="이메일을 선택해주세요."
                          onChange={handleEmailSelectChange}
                        >
                          <option value="">이메일을 선택해주세요.</option>
                          <option value="naver.com">naver.com</option>
                          <option value="gmail.com">gmail.com</option>
                          <option value="daum.com">daum.com</option>
                          <option value="nate.com">nate.com</option>
                          <option value="직접입력" className="user_write_email">
                            직접입력
                          </option>
                        </select>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="user_select_wrap">
                <div className="contact_user_title_wrap2">
                  <strong>2. 문의종류(중복가능)</strong>
                </div>

                <div className="contact_input_wrap type2">
                  <ul>
                    {inquiryTypes.map((type) => (
                      <li
                        key={type.id}
                        className={
                          type.hasTextInput ? "user_select_etc_wrap" : ""
                        }
                      >
                        <div>
                          <input
                            type="checkbox"
                            id={type.id}
                            name={type.formKey}
                            checked={form[type.formKey]}
                            onChange={handleFormChange}
                            className="hidden-checkbox"
                          />
                          <label htmlFor={type.id}>
                            <span className="custom-checkbox"></span>
                            {type.label}
                          </label>
                        </div>
                        {type.hasTextInput && (
                          <div>
                            <label
                              htmlFor={type.textInputKey}
                              className="blind"
                            ></label>
                            <input
                              className={`etc_text ${
                                !form[type.formKey] ? "dis" : ""
                              }`}
                              type="text"
                              id={type.textInputKey}
                              placeholder={type.placeholder}
                              disabled={!form[type.formKey]}
                              name={type.textInputKey}
                              onChange={handleFormChange}
                              value={
                                form[type.formKey]
                                  ? form[type.textInputKey]
                                  : ""
                              }
                              tabIndex={1}
                            />
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="user_select_wrap">
                <div className="contact_user_title_wrap2">
                  <strong>3. 개발 종류(중복가능)</strong>
                </div>

                <div className="contact_input_wrap type2 ">
                  <ul>
                    {DevelopmentType.map((type) => (
                      <li
                        key={type.id}
                        className={
                          type.hasTextInput ? "user_select_etc_wrap" : ""
                        }
                      >
                        <div>
                          <input
                            type="checkbox"
                            id={type.id}
                            name={type.formKey}
                            checked={form[type.formKey]}
                            onChange={handleFormChange}
                            className="hidden-checkbox"
                          />
                          <label htmlFor={type.id}>
                            <span className="custom-checkbox"></span>
                            {type.label}
                          </label>
                        </div>
                        {type.hasTextInput && (
                          <div>
                            <label
                              htmlFor={type.textInputKey}
                              className="blind"
                            ></label>
                            <input
                              className={`etc_text ${
                                !form[type.formKey] ? "dis" : ""
                              }`}
                              type="text"
                              id={type.textInputKey}
                              placeholder={type.placeholder}
                              disabled={!form[type.formKey]}
                              name={type.textInputKey}
                              onChange={handleFormChange}
                              value={
                                form[type.formKey]
                                  ? form[type.textInputKey]
                                  : ""
                              }
                              tabIndex={1}
                            />
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="user_inquiry_wrap">
                <div className="contact_user_title_wrap3">
                  <strong>4. 문의 내용</strong>
                </div>

                <div className="contact_input_wrap type3">
                  <textarea
                    className="user_inquiry_content"
                    placeholder="예상 개발 비용과 개발 기간을 작성해 주시면 상담에 더욱 도움이 됩니다."
                    tabIndex={1}
                    autoComplete="off"
                    title="내용"
                    name="inquiry"
                    value={form.inquiry}
                    onChange={handleFormChange}
                  />
                </div>
              </div>

              <div className="user_method_wrap">
                <div className="contact_user_title_wrap4 ">
                  <strong>5. 알게 된 경로(중복가능)</strong>
                </div>

                <div
                  className="contact_input_wrap type2
                type5"
                >
                  <ul>
                    {pathOptions.map((option) => (
                      <li
                        key={option.id}
                        className={
                          option.hasTextInput
                            ? "user_select_etc_wrap user_select_etc_wrap-w100"
                            : ""
                        }
                      >
                        <div>
                          <input
                            type="checkbox"
                            id={option.id}
                            name={option.formKey}
                            checked={form[option.formKey]}
                            onChange={handleFormChange}
                            className="hidden-checkbox"
                          />
                          <label htmlFor={option.id}>
                            <span className="custom-checkbox"></span>
                            <span>{option.label}</span>
                          </label>
                        </div>
                        {option.hasTextInput && (
                          <div>
                            <label
                              htmlFor={option.textInputKey}
                              className="blind"
                            ></label>
                            <input
                              className={`etc_text ${
                                !form[option.formKey] ? "dis" : ""
                              }`}
                              type="text"
                              id={option.textInputKey}
                              placeholder={option.placeholder}
                              disabled={!form[option.formKey]}
                              name={option.textInputKey}
                              onChange={handleFormChange}
                              value={
                                form[option.formKey]
                                  ? form[option.textInputKey]
                                  : ""
                              }
                              tabIndex={1}
                            />
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="user_method_wrap">
                <div className="contact_user_title_wrap4">
                  <strong>6. 답변 희망 수단</strong>
                </div>
                <div className="contact_input_wrap type2">
                  <ul style={{ justifyContent: "flex-start" }}>
                    <li>
                      <input
                        type="checkbox"
                        id="prefer_email"
                        name="preferEmail"
                        checked={form.preferEmail}
                        onChange={handleFormChange}
                        className="hidden-checkbox"
                      />
                      <label htmlFor="prefer_email">
                        <span className="custom-checkbox"></span>
                        이메일
                      </label>
                    </li>

                    <li>
                      <input
                        type="checkbox"
                        id="prefer_phone"
                        name="preferPhone"
                        checked={form.preferPhone}
                        onChange={handleFormChange}
                        className="hidden-checkbox"
                      />
                      <label htmlFor="prefer_phone">
                        <span className="custom-checkbox"></span>
                        전화
                      </label>
                    </li>
                  </ul>
                </div>
                <div className="user_personal_info_wrap">
                  <input
                    type="checkbox"
                    id="user_personal_info"
                    tabIndex={1}
                    name="personal"
                    checked={form.personal}
                    onChange={handleFormChange}
                    className="hidden-checkbox"
                  />
                  <label htmlFor="user_personal_info">
                    <span className="custom-checkbox"></span>
                    <span>*</span>(필수) 개인정보 수집 및 이용방침에 동의합니다.
                  </label>
                  <button onClick={contactDetailBtn}>전문보기</button>
                </div>
              </div>

              <div className="user_submit_wrap">
                <button className="user_submiy_mail" onClick={contactSubmit}>
                  <span></span>
                  문의하기
                </button>
              </div>
            </div>

            {modalBg && (
              <div className="contact_modal_wrap">
                <ContactDetailModal closeModal={closeModal} VW={VW} />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
